import { Calendar } from "lucide-react";

/** A filter expressed as a calendar time window. */
export type DateRangeByTime = {
  kind: "time";
  start: Date | null; // null means "beginning of time"
  end: Date | null; // null means "now"
  label: string;
};

/** A filter expressed as the last N assessments (count-based, data-driven). */
export type DateRangeByCount = {
  kind: "count";
  lastN: number;
  label: string;
};

export type DateRange = DateRangeByTime | DateRangeByCount;

interface DateRangeFilterProps {
  currentRange: DateRange;
  onRangeChange: (range: DateRange) => void;
}

type Preset = DateRange;

function buildPresets(): Preset[] {
  const now = new Date();

  const monthsAgo = (n: number): Date => {
    const d = new Date(now);
    d.setMonth(d.getMonth() - n);
    return d;
  };

  return [
    { kind: "count", lastN: 6, label: "Last 6 Assessments" },
    { kind: "time", start: monthsAgo(3), end: now, label: "Last 3 Months" },
    { kind: "time", start: monthsAgo(6), end: now, label: "Last 6 Months" },
    { kind: "time", start: monthsAgo(12), end: now, label: "Last Year" },
    { kind: "time", start: null, end: null, label: "All History" },
  ];
}

export function DateRangeFilter({
  currentRange,
  onRangeChange,
}: DateRangeFilterProps) {
  const presets = buildPresets();

  return (
    <div
      className="flex items-center bg-white rounded-lg shadow-sm border p-1"
      style={{ borderColor: "#E2E8F0" }}
    >
      <div className="px-3 text-slate-500 border-r mr-2">
        <Calendar size={16} />
      </div>
      <div className="flex gap-1">
        {presets.map((preset) => (
          <button
            key={preset.label}
            data-testid={`mbc-date-preset-${preset.label.replace(/[^a-zA-Z0-9]/g, "-").toLowerCase()}`}
            onClick={() => onRangeChange(preset)}
            className={`px-3 py-1.5 text-xs font-semibold rounded transition-colors ${
              currentRange.label === preset.label
                ? "bg-slate-100 text-slate-800"
                : "text-slate-600 hover:bg-slate-50 hover:text-slate-800"
            }`}
            style={
              currentRange.label === preset.label
                ? {
                    color: "#5A8DAB",
                    backgroundColor: "#F0F7FA",
                  }
                : {}
            }
          >
            {preset.label}
          </button>
        ))}
      </div>
    </div>
  );
}
